import { kPaxtonName } from '@/constants/constants-strings'

export default function SectionIntro({ error }: { error: boolean }) {
  return (
    <div className="px-4 pb-4 pt-3">
      <p className="text-base font-semibold leading-7 text-text-primary">Document Management</p>
      {error ? (
        <p className="text-sm leading-5 tracking-[-0.15px] text-red-700">Connected accounts could not be loaded. Refresh the page and try again.</p>
      ) : (
        <p className="text-sm leading-5 tracking-[-0.15px] text-text-tertiary">
          Connect your files to access them in {kPaxtonName}. You control which folders to share, and your files are never modified or deleted.
        </p>
      )}
    </div>
  )
}
